"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundedXLarge = exports.roundedSmall = exports.roundedNone = exports.roundedMedium = exports.roundedLarge = exports.roundedFull = exports.rounded = exports.borderRadiusVariables = void 0;
require("./borderRadius.css");
var _borderRadius2 = require("@cbhq/cds-common/tokens/borderRadius");
var _tokens = require("../tokens");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

// eslint-disable-next-line no-restricted-imports

const borderRadiusVariables = {
  '--border-radius-rounded-none': `${_borderRadius2.borderRadius.roundedNone}px`,
  '--border-radius-rounded-small': `${_borderRadius2.borderRadius.roundedSmall}px`,
  '--border-radius-rounded': `${_borderRadius2.borderRadius.rounded}px`,
  '--border-radius-rounded-medium': `${_borderRadius2.borderRadius.roundedMedium}px`,
  '--border-radius-rounded-large': `${_borderRadius2.borderRadius.roundedLarge}px`,
  '--border-radius-rounded-x-large': `${_borderRadius2.borderRadius.roundedXLarge}px`,
  '--border-radius-rounded-full': `${_borderRadius2.borderRadius.roundedFull}px`
};
exports.borderRadiusVariables = borderRadiusVariables;
const roundedNone = "cds-roundedNone-r1jbj4y7";
exports.roundedNone = roundedNone;
const roundedSmall = "cds-roundedSmall-ry3f2yl";
exports.roundedSmall = roundedSmall;
const rounded = "cds-rounded-r2fqqz3";
exports.rounded = rounded;
const roundedMedium = "cds-roundedMedium-r11psehb";
exports.roundedMedium = roundedMedium;
const roundedLarge = "cds-roundedLarge-rdc2t5d";
exports.roundedLarge = roundedLarge;
const roundedXLarge = "cds-roundedXLarge-rif089s";
exports.roundedXLarge = roundedXLarge;
const roundedFull = "cds-roundedFull-rbuu10h";
exports.roundedFull = roundedFull;